import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    SimplePopupWrapper,
    SimplePopupHeader,
    CloseIconWrapper,
    ContentWrapper,
    ContentLink,
} from './PopupContainer.style';
import { PopupHelpAndContactType } from 'src/domains/layouts/state/popupState/PopupState';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';

interface HelpAndContactPopupPropsType {
    popup: PopupHelpAndContactType;
}

export const HelpAndContactPopup = observer(
    'HelpAndContactPopup',
    (props: HelpAndContactPopupPropsType): JSX.Element => {
        const common = useCommon();
        const appLayoutsState = AppLayoutsState.get(common);
        const { popupState } = appLayoutsState;
        const { popup } = props;

        return (
            <SimplePopupWrapper>
                <SimplePopupHeader>
                    <I18n
                        langKey='popup-state.header.help-support'
                        defaultText='Help & Support'
                    />
                    <CloseIconWrapper onClick={popupState.hide} />
                </SimplePopupHeader>
                <ContentWrapper>
                    {popup.textPart1}
                    <ContentLink href={`mailto:${popup.email}`}>{popup.email}</ContentLink>
                    {popup.textPart2}
                </ContentWrapper>
            </SimplePopupWrapper>
        );
    }
);
